import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

const ISO_DATETIME_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})?$/;

function toUtcDateOnly(isoString: string): string {
  // Period dates are built as UTC instants (Date.UTC), so read them in UTC.
  // Reading in local time would shift end-of-month 23:59:59.999Z to the next day (UTC+2).
  const d = new Date(isoString);
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;
}

export class DateOnlyParamInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let params = req.params;
    let changed = false;

    for (const key of params.keys()) {
      const values = params.getAll(key) ?? [];
      const fixed = values.map(v =>
        typeof v === 'string' && ISO_DATETIME_RE.test(v) ? toUtcDateOnly(v) : v
      );
      if (fixed.some((v, i) => v !== values[i])) {
        params = params.delete(key);
        fixed.forEach(v => { params = params.append(key, v); });
        changed = true;
      }
    }

    return next.handle(changed ? req.clone({params}) : req);
  }
}
